import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from "./UserAppResource";

export const CAR = 'bd3df834-ed7b-4eb4-8b48-6b21ba225fac';

class LuPointOfOriginAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'lu-point-of-origin';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'lus/points/of/origin';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'created_at',
      'updated_at',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'name',
      'slug',
      'description',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      users: UserAppResource
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      name: {
        type: 'string',
        presence: true,
      },
      slug: {
        type: 'string',
      },
      description: {
        type: 'string'
      }
    };
  }

}

export default LuPointOfOriginAppResource;
